"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = require("owa-session-store");
var loadTheme_1 = require("owa-theme/lib/actions/loadTheme");
function discardThemeChange() {
    loadTheme_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
}
exports.default = discardThemeChange;
//# sourceMappingURL=discardThemeChange.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/orchestration/discardThemeChange.js
// module id = 4960
// module chunks = 2